import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Modal, Pagination, Dimmer, Loader, Segment, Header, Icon, Table, Button, Grid, Confirm } from 'semantic-ui-react'
import closeIcon from '../../../assets/images/newui/close.png'
import "./RequestNotesModal.less"
import { getSCRequestNotesList } from '../../../services/Seller'
import moment from 'moment';
import { deleteSCRequestNote } from '../../../services/Seller'

function RequestNotesModal({ selectedRequest, isOpen, onClose, header, handleAddNoteClick, showAddNote = false, allowDelete = false }) {

  const [requestNotesState, setRequestNotesState] = useState([]);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedNote, setSelectedNote] = useState(undefined)
  const [isNoteDeleted, setIsNoteDeleted] = useState(false)

  const loadData = async (scRequestID) => {
    let res = await getSCRequestNotesList(scRequestID);
    if (res.resStatus == 200) {
      console.log("res.data", res.data)
      setRequestNotesState(res.data);
    }
  }
  const onNoteDeleteClick = (selectedNote) => {
    setSelectedNote(selectedNote)
    setShowDeleteConfirmModal(true)
  }

  const handleModalClose = () => {
    onClose(isNoteDeleted)
  }
  const onNoteDeleteConfirm = async () => {

    if (!selectedRequest) return
    if (!selectedNote) return

    let res = await deleteSCRequestNote(selectedRequest.scRequestID, selectedNote.scrNoteID);
    if (res.resStatus == 200) {
      await loadData(selectedRequest.scRequestID);
      setIsNoteDeleted(true)
      setShowDeleteConfirmModal(false)
    }
  }

  useEffect(() => {
    if (isOpen && selectedRequest && selectedRequest.scRequestID) {
      console.log("selectedRequest", selectedRequest)
      loadData(selectedRequest.scRequestID);
    }
  }, [isOpen, selectedRequest])

  return (
    <>

      <Modal
        open={isOpen}
        closeOnDimmerClick={false}
        onClose={() => handleModalClose()}
        className="request-notes-modal"
      >
        <div>
          <div className="header">
            <div
              className="close-button"
              onClick={() => handleModalClose()}
            >
              <img src={closeIcon}></img>
            </div>
            <div className="main-heading">{header || "Additional Details"} </div>
          </div>
          <div className="body">
            {
              <>
                <Table celled>

                  {
                    window.innerWidth < 768 ?
                      showAddNote &&
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>
                            <div className='add-note-button-container'>
                              <div>
                                <Button onClick={() => {
                                  handleAddNoteClick && handleAddNoteClick(selectedRequest)
                                }}
                                  className={"add-item-button"}>
                                  + Add
                                </Button>
                              </div>
                            </div>
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                           :
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell style={{
                            width: "20%"
                          }}>Created At</Table.HeaderCell>
                          <Table.HeaderCell>
                            <div className='add-note-button-container'>
                              <span>
                                Message
                              </span>
                              {
                                showAddNote &&
                                <div>
                                  <Button onClick={() => {
                                    handleAddNoteClick && handleAddNoteClick(selectedRequest)
                                  }}
                                    className={"add-item-button"}>
                                    + Add
                                  </Button>
                                </div>
                              }
                            </div>
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                  }
                  <Table.Body>
                    {
                      requestNotesState.map((note) => {
                        return <>
                          <Table.Row>
                            <Table.Cell>{moment(note.createdAt).format('LLL')}</Table.Cell>
                            <Table.Cell>
                              <div className='message-row-container'>
                                <div>
                                  {
                                    note.message
                                  }
                                </div>
                                {
                                  allowDelete &&
                                  <div>
                                    <Icon color={"red"} name='trash alternate outline' onClick={() => { onNoteDeleteClick(note) }}></Icon>
                                  </div>
                                }
                              </div>
                            </Table.Cell>
                          </Table.Row>
                        </>
                      })
                    }
                  </Table.Body>
                </Table>
              </>
            }
          </div>
        </div>
      </Modal>
      <Confirm open={showDeleteConfirmModal} className='delete-confirm-modal'
        onCancel={() => setShowDeleteConfirmModal(false)}
        onConfirm={onNoteDeleteConfirm}
        content='Are you sure you want to delete this note ? This action cannot be undone.'
        cancelButton='No'
        confirmButton="Yes, Delete"
      ></Confirm>
    </>
  );
}

export default RequestNotesModal